import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-extrabold text-foreground-950 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            关于吃瓜网51的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-4">
          {faqItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6"
            >
              <h3 className="text-base md:text-lg font-bold text-foreground-900 mb-3 font-heading flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 text-lg">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-8">
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}